/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

import { Button } from 'omakase';
import { SearchQueryStringParams } from 'components/search/utils';
import { SearchSizeType } from 'utils/searchBar';
import { TockProductType } from '@tock/shared/types/productFeatures';
import { consumer, core } from '@tock/coretypes';
import { oc } from 'ts-optchain';
import { useQueryStringParams } from 'hooks/useQueryStringParams';
import ConsumerProductFeatureRestriction from 'components/product/ConsumerProductFeatureRestriction';
import LoadingComponent from '@tock/shared/components/LoadingComponent';
import OfferingsStatusMessage from 'components/business/offering/OfferingsStatusMessage';
import ReservationSearchBar from 'components/business/landing-page/ReservationSearchBar/ReservationSearchBar';
import clsx from 'clsx';

interface Props {
  business: consumer.IBusinessConfig;
  hasOfferings: boolean;
  isLoading: boolean;
  nextRelease?: core.IBookingRelease;
  locality: string;
  offerings: consumer.ConsumerOfferings;
  onMobileSearch(): void;
  onSearch(size: number, date: any, time: any): void;
  showBusinessCard: boolean;
  soldOut: boolean;
}
export const ProfileSearch: React.FunctionComponent<Props> = ({
  business,
  hasOfferings,
  isLoading,
  nextRelease,
  offerings,
  onMobileSearch,
  onSearch,
  showBusinessCard,
  soldOut,
}) => {
  const { date, time, size: sizeParam } = useQueryStringParams<SearchQueryStringParams>();
  const urlSize = sizeParam ? parseInt(sizeParam, 10) : undefined;
  const showSearchBar = !soldOut && !business.hideConsumerSearch && hasOfferings;
  const isAuthorized = oc(business).isAuthorized(false);
  const showStatus = !isLoading && isAuthorized && !business.hideConsumerSearch;
  const showStatusMessageMobile = soldOut || !hasOfferings;

  const statusMessageClassname = clsx('ProfileSearch-offeringsStatusMessage', {
    'is-hiddenMobile': !showStatusMessageMobile,
  });

  const profileSearchClassname = clsx('ProfileSearch', {
    'is-hiddenMobile': !showSearchBar && (!showStatus || !showStatusMessageMobile),
  });

  return (
    <div className={profileSearchClassname} data-testid="profile-search">
      {showSearchBar && (
        <LoadingComponent isLoading={isLoading} isBallPulse>
          <ReservationSearchBar
            showBusinessCard={showBusinessCard}
            business={business}
            offerings={offerings}
            onSearch={onSearch}
            searchSizeType={SearchSizeType.PARTY_SIZE}
            date={date}
            time={time}
            size={urlSize}
          />
          <div className="ProfileSearch-mobileSearchButton">
            <Button fullWidth variant="primary" size="large" onClick={onMobileSearch}>
              Book now
            </Button>
          </div>
        </LoadingComponent>
      )}
      <ConsumerProductFeatureRestriction onlyForProductType={TockProductType.CLASSIC}>
        {showStatus && (
          <div className={statusMessageClassname}>
            <OfferingsStatusMessage
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              businessName={business.name!}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              businessTicketsAvailableUntil={business.ticketsAvailableUntil!}
              hasOfferings={hasOfferings}
              nextRelease={nextRelease}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              offeringsDisabled={business.bookingsDisabled!}
              soldOut={soldOut}
              styleAsCard={!showSearchBar}
            />
          </div>
        )}
      </ConsumerProductFeatureRestriction>
    </div>
  );
};
